import { c as _c } from "react/compiler-runtime";
import { NotificationCardSkeleton } from "@/components/notifications/notification-card-skeleton";
interface NotificationListSkeletonProps {
  /** Number of skeleton cards to render. Defaults to 4. */
  count?: number;
}
export function NotificationListSkeleton(t0) {
  const $ = _c(4);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 4 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = Array.from({
      length: count
    }, _temp);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const skeletonIds = t2;
  let t3;
  if ($[2] !== skeletonIds) {
    t3 = <div className="divide-y">{skeletonIds.map(_temp2)}</div>;
    $[2] = skeletonIds;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2(skeletonId) {
  return <NotificationCardSkeleton key={skeletonId} />;
}
function _temp(_, itemNumber) {
  return `notification-skeleton-${itemNumber}`;
}